/*
 *
 * SendDirectlyPopup
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 21-Jan-2025
 */

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { doPopup } from 'Store/actions/popup'
import * as CreatePayByLinkPlusActions from 'Route/CreatePayByLinkPlus/modules/CreatePayByLinkPlusActions'
import * as BookingManagementActions from 'Route/BookingManagement/modules/BookingManagementActions'
import * as PayToCardActions from 'Route/PayToCard/modules/PayToCardActions'
import SendDirectlyPopup from './SendDirectlyPopup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(CreatePayByLinkPlusActions, dispatch),
  ...bindActionCreators(BookingManagementActions, dispatch),
  ...bindActionCreators(PayToCardActions, dispatch),
  closePopup: () => dispatch(doPopup(''))
})

const mapStateToProps = (state) => ({
  result: state?.popup?.popupData || {},
  //generatePayByLinkResult: state?.CreatePayByLinkPlus?.generatePayByLinkResult || {},
  requestForm: state?.formik?.formikForm?.PBLForm || {},
  isLoading:
    state?.loading?.local_PBLsendDirectly ||
    state?.loading?.local_PTCsendDirectly ||
    state?.loading?.local_BookingsManagementExecuteAction ||
    false
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(SendDirectlyPopup)
